/**
 * @generated SignedSource<<00e00136d01fb178195af8cd4f5f5177>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
import { FragmentRefs } from "relay-runtime";
export type SelectableGolfRound_Round$data = {
  readonly courseLayout: {
    readonly holeCount: HoleCount;
  } | null | undefined;
  readonly id: string;
  readonly player: {
    readonly id: string;
  } | null | undefined;
  readonly roundRate: {
    readonly rate: {
      readonly name: string;
    };
  } | null | undefined;
  readonly transportationType: {
    readonly code: TransportationCode | null | undefined;
    readonly customCode: string | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SelectableGolfRound_Round";
};
export type SelectableGolfRound_Round$key = {
  readonly " $data"?: SelectableGolfRound_Round$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectableGolfRound_Round">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectableGolfRound_Round",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundRate",
      "kind": "LinkedField",
      "name": "roundRate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "rate",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TransportationType",
      "kind": "LinkedField",
      "name": "transportationType",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customCode",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseLayout",
      "kind": "LinkedField",
      "name": "courseLayout",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "holeCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "player",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Round",
  "abstractKey": "__isRound"
};
})();

(node as any).hash = "4730489cc2f825644630b883df94eec8";

export default node;
